<div id="transport">
  <ng-container *ngFor="let day of days; let index = index">
    <div *ngIf="hasDayContent(day)">
      <div class="container-fluid card card-body sticky-top day-header">
        <div class="row">
          <div class="col-12 text-secondary text-uppercase center">
            <span class="text-08em">
              {{ day.date | localizedDate: "MMM dd, yyyy"}}
            </span>
          </div>
          <div class="col-12 text-capitalize center">
            <span class="text-13em">{{ day.date | localizedDate: "EEEE" }}</span>
          </div>
        </div>
      </div>
      <app-flights *ngIf="showFlights" [day]="day" [enableFlightPassengers]="enableFlightPassengers"></app-flights>
      <app-transfers *ngIf="showTransfers" [day]="day" [version]="version" [noImageUrl]="noImageUrl" [defaultImage]="defaultImage" [showOptionlServices]="showOptionlServices"
        [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes" [serviceIcons]="serviceIcons"></app-transfers>
    </div>
  </ng-container>
</div>